import { render, staticRenderFns } from "./ClientDeadlinesFullCalendar.vue?vue&type=template&id=8a4f2a20&scoped=true"
import script from "./ClientDeadlinesFullCalendar.vue?vue&type=script&lang=js"
export * from "./ClientDeadlinesFullCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4f2a20",
  null
  
)

export default component.exports